export default function (state = false, action) {
  switch (action.type) {
    case "GET_MESSAGE":
      return action.payload;
      break;
    default:
      return state;
  }
}
